import React from 'react';
import {NavLink} from 'react-router-dom';
import './Sidebar.css';
import Spinner from '../UI/Spinner/Spinner';

const Sidebar = (props) => {

    let content = <Spinner></Spinner>;
    const height = window.innerHeight - 100;
    
    if(!props.loading && typeof props.configs.Menu !== 'undefined' && props.configs.Menu.length > 0) {
        const menu = props.configs.Menu;
        content = (
            <ul className="sidebar-menu" data-widget="tree">
                <li className="header">MAIN NAVIGATION</li>
                {
                    menu.map((value, key) => {
                        if(!value.status) {
                            return null;
                        }
                        return (
                            <li key={key}>
                                <NavLink exact activeClassName="active" to={value.to}>
                                    <span>{value.name}</span>
                                </NavLink>
                            </li>
                        );
                    })
                }
                {/* <li>
                    <NavLink exact activeClassName="active" to={`/eber/eWZLT3RzcWRyODM0ajRRU2tlWExnbm4yMWpGNE5Wd1BJSml1aFZrbDo=`}>Eber</NavLink>
                </li> */}
            </ul>
        );
    }

    return (
        <div className="Sidebar">
            <aside className="main-sidebar">
                <section className="sidebar" style={{
                    height: height,
                }}>
                    {content}
                </section>
            </aside>
        </div>
    )
}

export default Sidebar;